import { CSSProperties, useEffect, useState } from 'react';

import './index.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Info } from "../../../../assets/svgs/info.svg";
import { ReactComponent as Flight } from "../../../../assets/svgs/flight.svg";

import { ReactComponent as Overview } from "../../../../assets/svgs/overview.svg";

import { ISidebarMenuItem, onActiveLink, SideBarMenuItem } from '../sidebar-menu-item/SideBarMenuItem';
import { ISidbarProps, MENUPOSITION } from '../../model';
import { useDssContext } from '../../../../DSSContext';
import { notifyError } from '../../../../ui/dls/dls-snackbar/dls-snackbar';
import { ENDPOINTS } from '../../../subscriptions/api/end-point';
import { commonPostServiceApi } from '../../../../services/api-service';
import { ROUTER_PATHS as ROUTER_PATHS_USERCARE } from '../../../user-care/constant/constant';
import { ROUTER_PATHS as ROUTER_PATHS_Distribution} from '../../../distribution/constant/router-contant';
import { getViewReports, type ReportItem } from '../../../user-care/api/reports-api';

export const SideBarUser = (props: ISidbarProps & { refreshCounts?: React.MutableRefObject<() => void> }) => {
  const location = useLocation();
  const navgt = useNavigate();
  const togap = { marginTop: "0" } as CSSProperties;
  const { userDetail, t, active } = useDssContext();
  const [isExistingCustomer, setIsExistingCustomer] = useState<boolean>(false);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [reportsList, setReportsList] = useState<ReportItem[]>([]);
  const [loadingReports, setLoadingReports] = useState<boolean>(false);

  // Function to close all submenus
  // const closeAllSubMenus = () => setOpenSubMenu(null);

  const [showReports, setShowReports] = useState(false);
  const closeReports = () => setShowReports(false);
  useEffect(() => {
    if (!active || active.trim() === '') {
      setOpenSubMenu(null);
      setShowReports(false);
    }
  }, [active]);
  useEffect(() => {
    // setIsExistingCustomer((userDetail?.customers ?? []).length > 0);
    setIsExistingCustomer(true)
  }, [userDetail?.honeywellId]);
  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoadingReports(true);
        const reports = await getViewReports();
        setReportsList(Array.isArray(reports) ? reports : []);
      } catch (err: any) {
        notifyError(err);
      } finally {
        setLoadingReports(false);
      }
    };
    fetchReports();
  }, []);

  const navigate = (path: string, closeSideBar?: boolean, state?: any) => {
    // closeAllSubMenus();
    // closeSideBar ?? props.onMenuClick();
    navgt(path, state ? { state } : undefined);
  };
  const role = 1
  const [subscriptionCount, setSubscriptionCount] = useState<any>({});

  useEffect(() => {
    if (props.refreshCounts) {
      props.refreshCounts.current = fetchSubscriptionCounts;
    }
    // fetchSubscriptionCounts();
  }, []);
  const fetchSubscriptionCounts = async () => {
    try {
      const result = await commonPostServiceApi<any>(ENDPOINTS.getAllSubscriptionCounts)
      setSubscriptionCount(result)
    } catch (err: any) {
      notifyError(err.message || "Failed to fetch search results");
    }
  };
  return (
    <div
      className={`sidebarmenu ${props.menuPosition === MENUPOSITION.HORIZONTAL ? "top" : "side"
        }`}
    >
      <SideBarMenuItem
        title="Overview"
        style={togap}
        leftmenu={props.leftmenu}
        hasIcon={true}
        iconAssetPath={Overview}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="Overview"
        className={onActiveLink(location.pathname.toString().indexOf("/overview") > -1)}
        active={activeMenu === "Overview" ? "active" : ""}
        onClick={() => {
          navigate(`/userlogin/overview`);
          setActiveMenu("Overview");
        }}
      />
      <SideBarMenuItem
        active={activeMenu === "Support" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="Support"
        style={togap}
        hasIcon={true}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="Support"
        iconAssetPath={Info}
        className={onActiveLink(location.pathname.toString().indexOf("support") > -1)}
        onClick={() => {
          setActiveMenu("Support");
        }}
        subMenus={[
          {
            leftmenu: props.leftmenu,
            title: "Products and Services",
            className: onActiveLink(location.pathname.toString().indexOf("product") > -1),
            onClick: () => navigate(`/userlogin/support/product`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Customer Support",
            className: onActiveLink(location.pathname.toString().indexOf("customerSupport") > -1),
            onClick: () => navigate(`/userlogin/support/customerSupport`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Online Help",
            className: onActiveLink(location.pathname.toString().indexOf("onlineHelp") > -1),
            onClick: () => navigate(`/userlogin/support/onlineHelp`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Quality Documents",
            className: onActiveLink(location.pathname.toString().indexOf("qualityDocuments") > -1),
            onClick: () => navigate(`/userlogin/support/qualityDocuments`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Tools & Tech Info",
            className: onActiveLink(location.pathname.toString().indexOf("toolsInfo") > -1),
            onClick: () => navigate(`/userlogin/support/toolsInfo`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "News & Events",
            className: onActiveLink(location.pathname.toString().indexOf("newsEvents") > -1),
            onClick: () => navigate(`/userlogin/support/newsEvents`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Purchase New Services **",
            onClick: () => { window.open("https://shop.jeppesen.com/INDS", "_blank", "noopener,noreferrer") },
          } as ISidebarMenuItem,
        ]}
      />
      <SideBarMenuItem
        active={activeMenu === "Flight" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="Flight Info"
        style={togap}
        hasIcon={true}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="Flight"
        iconAssetPath={Info}
        className={onActiveLink(location.pathname.toString().indexOf("flight-info") > -1)}
        onClick={() => {
          setActiveMenu("Flight");
        }}
        subMenus={[
          {
            leftmenu: props.leftmenu,
            title: "Alerts/Notices",
            className: onActiveLink(location.pathname.toString().indexOf("alerts-and-notices") > -1),
            onClick: () => navigate(`/userlogin/flight-info/alerts-and-notices`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "DataBase/MediaType",
            className: onActiveLink(location.pathname.toString().indexOf("/database-mediatype") > -1),
            onClick: () => navigate(`/userlogin/flight-info/database-mediatype`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "EGPWS Terr DB Search",
            className: onActiveLink(location.pathname.toString().indexOf("egpws-search") > -1),
            onClick: () => navigate(`/userlogin/flight-info/egpws-search`),
          } as ISidebarMenuItem,
        ]}
      />
      <SideBarMenuItem
        active={activeMenu === "myAccount" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="My Account"
        style={togap}
        hasIcon={true}
        iconAssetPath={Flight}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="myAccount"
        className={onActiveLink(location.pathname.toString().indexOf("my-account") > -1)}
        onClick={() => {
          setActiveMenu("myAccount");
        }}
        subMenus={[
          {
            leftmenu: props.leftmenu,
            title: "Profile",
            className: onActiveLink(location.pathname.toString().indexOf("profile") > -1),
            onClick: () => navigate('/userlogin/my-account/profile'),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Subscriptions",
            className: onActiveLink(location.pathname.toString().indexOf("subscription") > -1),
            onClick: () => navigate('/userlogin/my-account/subscription'),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Download Tracker",
            className: onActiveLink(location.pathname.toString().indexOf("download-tracker") > -1),
            onClick: () => navigate('/userlogin/my-account/download-tracker'),
          } as ISidebarMenuItem,
           {
            leftmenu: props.leftmenu,
            title: "Primus Elite Options",
            className: onActiveLink(location.pathname.toString().indexOf("primus-elite") > -1),
            onClick: () => navigate('/userlogin/my-account/primus-elite'),
          } as ISidebarMenuItem,
        ]}
      />
      <SideBarMenuItem
        active={activeMenu === "Databases" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="Databases"
        style={togap}
        hasIcon={true}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="Databases"
        iconAssetPath={Flight}
        className={onActiveLink(location.pathname.toString().indexOf("database") > -1)}
        onClick={() => {
          setActiveMenu("Databases");
        }}
        subMenus={[
          {
            leftmenu: props.leftmenu,
            title: "My Downloads",
            className: onActiveLink(location.pathname.toString().indexOf("download") > -1),
            onClick: () => navigate(role === 1 ? '/userlogin/database/admin-download' : '/userlogin/database/download'),
          } as ISidebarMenuItem,
        ]}
      />
      <SideBarMenuItem
        active={activeMenu === "Subscription" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="Subscriptions"
        style={togap}
        hasIcon={true}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="Subscription"
        iconAssetPath={Flight}
        className={onActiveLink(location.pathname.toString().indexOf("subscription") > -1)}
        onClick={() => {
          setActiveMenu("Subscription");
        }}
        subMenus={[
          {
            leftmenu: props.leftmenu,
            title: "Add Part 2",
            className: onActiveLink(location.pathname.toString().indexOf("addpart2") > -1),
            onClick: () => navigate('/userlogin/subscription/addpart2'),
            count: subscriptionCount.addPart2SubCount,
            badgeClass: "part2-badge"

          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Modify",
            className: onActiveLink(location.pathname.toString().indexOf("modify") > -1),
            onClick: () => navigate('/userlogin/subscription/modify'),
            count: subscriptionCount.modifiedSubsCount,
            badgeClass: "modify-badge"
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Exceptions",
            className: onActiveLink(location.pathname.toString().indexOf("exception") > -1),
            onClick: () => navigate('/userlogin/subscription/exception'),
            count: subscriptionCount.errorSubCount,
            badgeClass: "exception-badge"
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Active",
            className: onActiveLink(location.pathname.toString().indexOf("active") > -1),
            onClick: () => navigate('/userlogin/subscription/active'),
            count: subscriptionCount.activeSubCount,
            badgeClass: "active-badge"
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Expired",
            className: onActiveLink(location.pathname.toString().indexOf("expire") > -1),
            onClick: () => navigate('/userlogin/subscription/expire'),
            count: subscriptionCount.expiredCount,
            badgeClass: "error-badge"
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Search Subscription",
            className: onActiveLink(location.pathname.toString().indexOf("globalSearch") > -1),
            onClick: () => navigate('/userlogin/subscription/globalSearch'),
          } as ISidebarMenuItem,

        ]}
      />
      <SideBarMenuItem
        active={activeMenu === "UserCare" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="User Care"
        style={togap}
        hasIcon={true}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="UserCare"
        iconAssetPath={Flight}
        className={onActiveLink(location.pathname.toString().indexOf("user-care") > -1)}
        onClick={() => {
          setActiveMenu("UserCare");
        }}
        subMenus={[
          {
            leftmenu: props.leftmenu,
            title: "Contact Administration",
            className: onActiveLink(location.pathname.toString().indexOf("contact-adminstration") > -1),
            onClick: () => { closeReports(); navigate('/userlogin/user-care/contact-adminstration'); },
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "INDS Share",
            className: onActiveLink(location.pathname.toString().indexOf("inds-share") > -1),
            onClick: () => { closeReports(); navigate('/userlogin/user-care/inds-share'); },
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Guest Account Management",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_USERCARE.Guest_Account) > -1),
            onClick: () => { closeReports(); navigate(`${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Guest_Account}`); },
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Track Downloads",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_USERCARE.Track_Downloads) > -1),
            onClick: () => { closeReports(); navigate(`${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Track_Downloads}`); },
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Reports",
            active:
              (location.pathname.toString().indexOf(ROUTER_PATHS_USERCARE.Reports.reports) > -1 || showReports)
                ? "active"
                : "",
            childsubmenuOpen: showReports,
            subMenus: (() => {
              const items = reportsList.map(r => ({
                leftmenu: props.leftmenu,
                title: r.reportName,
                className: onActiveLink(location.pathname.toString().indexOf(`${ROUTER_PATHS_USERCARE.Reports.reports}/${r.reportId}`) > -1),
                onClick: () => {
                  setShowReports(true);
                  navigate(
                    `${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.Reports.reports}/${r.reportId}`,
                    false,
                    { title: r.reportName }
                  );
                }
              } as ISidebarMenuItem));
              if (loadingReports && items.length === 0) {
                return [{ leftmenu: props.leftmenu, title: 'Loading...', className: '', onClick: () => {} } as ISidebarMenuItem];
              }
              return items;
            })(),
            onClick: () => setShowReports(prev => !prev)
          } as ISidebarMenuItem,




          {
            leftmenu: props.leftmenu,
            title: t('broadcastPromotion.modulename'),
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_USERCARE.BROADCAST_PROMOTIONS) > -1),
            onClick: () => { closeReports(); navigate(`${ROUTER_PATHS_USERCARE.USER_CARE}/${ROUTER_PATHS_USERCARE.BROADCAST_PROMOTIONS}`); },
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Operator Admin",
            className: onActiveLink(location.pathname.toString().indexOf("operator-admin") > -1),
            onClick: () => { closeReports(); navigate('/userlogin/user-care/operator-admin'); },
          } as ISidebarMenuItem,
        ]}
      />
      <SideBarMenuItem
        active={activeMenu === "Distribution" ? "active" : ""}
        leftmenu={props.leftmenu}
        title="Distribution"
        style={togap}
        hasIcon={true}
        openSubMenu={openSubMenu}
        setOpenSubMenu={setOpenSubMenu}
        menuKey="Distribution"
        iconAssetPath={Flight}
        className={onActiveLink(location.pathname.toString().indexOf("distribution") > -1)}
        onClick={() => {
          setActiveMenu("Distribution");
        }}
        subMenus={[
        
          {
            leftmenu: props.leftmenu,
            title: "Cycle Dashboard",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_Distribution.CycleDashboard) > -1),
            onClick: () => navigate(`${ROUTER_PATHS_Distribution.Distribution}/${ROUTER_PATHS_Distribution.CycleDashboard}`),
          } as ISidebarMenuItem,
            {
            leftmenu: props.leftmenu,
            title: "Generate/View Packslip",
            className: onActiveLink(location.pathname.toString().indexOf("pack-slip") > -1),
            onClick: () => navigate('/userlogin/distribution/pack-slip'),
          } as ISidebarMenuItem,
           {
            leftmenu: props.leftmenu,
            title: "Generate Validation Letters",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_Distribution.ValidationLetter.GenerateValidationLetters) > -1),
            onClick: () => navigate(`${ROUTER_PATHS_Distribution.Distribution}/${ROUTER_PATHS_Distribution.ValidationLetter.GenerateValidationLetters}`),
          } as ISidebarMenuItem,
           {
            leftmenu: props.leftmenu,
            title: "View Shipment Summary",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_Distribution.ViewShipmentSummary) > -1),
            onClick: () => navigate(`${ROUTER_PATHS_Distribution.Distribution}/${ROUTER_PATHS_Distribution.ViewShipmentSummary}`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "Generate NAR",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_Distribution.Nar.GenerateNAR) > -1),
            onClick: () => navigate(`${ROUTER_PATHS_Distribution.Distribution}/${ROUTER_PATHS_Distribution.Nar.GenerateNAR}`),
          } as ISidebarMenuItem,
          {
            leftmenu: props.leftmenu,
            title: "BOM Simulator",
            className: onActiveLink(location.pathname.toString().indexOf(ROUTER_PATHS_Distribution.Bom) > -1),
            onClick: () => navigate(`${ROUTER_PATHS_Distribution.Distribution}/${ROUTER_PATHS_Distribution.Bom}`),
          } as ISidebarMenuItem,
        ]}
      />

    </div>
  );
};